import styled from 'styled-components';
import colors from 'constants/colors';

export const ItemRendererContainer = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  font-size: 14px;
  color: ${colors.silver};

  .row {
    width: 100%;
    line-height: 26px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;

    .increase {
      width: 50%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      font-weight: bold;
      color: ${colors.lightGreen};
    }

    .decrease {
      width: 50%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      font-weight: bold;
      color: ${colors.red};
    }

    .textHighlight {
      width: 50%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      font-weight: bold;
      color: ${colors.white};
    }

    .text {
      width: 50%;
      color: ${(props) => props.today ? colors.white: null};
    }
  }
`;

export const SideBarItemContainer = styled.div`

  cursor: pointer;
  height: ${(props) => props.rowHeight ? props.rowHeight + 'px' : '70px'};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: ${colors.silver};
`;

export const SubHeaderContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: black;
  color: ${colors.white};
  padding-left: 10px;

  .contentContainer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-left: 10px;
    margin-bottom: 10px;

    .dateSection {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 170px;
    }
  }
`;

